/**
 * ヘッダー言語切替・サイト内検索（本番 languageBtn / searchBtn 相当）
 */

const LANG_DESKTOP_MQ = "(min-width: 737px)";

/**
 * languageBtn: PC幅のみクリックで言語リストを開閉
 */
export function initHeaderLang() {
  const langRoot = document.querySelector(".js-header-lang");
  const trigger = langRoot?.querySelector(".l-header-lang");
  const list = document.getElementById("js-header-lang-list");

  if (!langRoot || !trigger || !list) return;

  const mq = window.matchMedia(LANG_DESKTOP_MQ);
  let isOpen = false;

  const setOpen = (open) => {
    if (!mq.matches) {
      isOpen = false;
      langRoot.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
      list.hidden = true;
      return;
    }

    isOpen = open;
    langRoot.classList.toggle("is-open", open);
    trigger.setAttribute("aria-expanded", String(open));
    list.hidden = !open;
  };

  trigger.addEventListener("click", () => {
    if (!mq.matches) return;
    setOpen(!isOpen);
  });

  document.addEventListener("click", (event) => {
    if (!mq.matches || !isOpen) return;
    if (!langRoot.contains(event.target)) {
      setOpen(false);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && isOpen) {
      setOpen(false);
      trigger.focus();
    }
  });

  const handleBreakpointChange = () => {
    setOpen(false);
  };

  if (typeof mq.addEventListener === "function") {
    mq.addEventListener("change", handleBreakpointChange);
  } else {
    mq.addListener(handleBreakpointChange);
  }
}

/**
 * searchBtn: Googleサイト内検索（空送信を防止）
 */
export function initHeaderSearch() {
  const forms = document.querySelectorAll("#js-header-search, #js-drawer-search");

  forms.forEach((form) => {
    const input = form.querySelector('input[name="q"]');

    if (!input) return;

    form.addEventListener("submit", (event) => {
      if (!input.value.trim()) {
        event.preventDefault();
        input.focus();
      }
    });
  });
}

export default function initHeaderLangSearch() {
  initHeaderLang();
  initHeaderSearch();
}
